'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Radio = require('../Radio/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _Group = require('../Group/Group');

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioGroup = function (_Component) {
    _inherits(RadioGroup, _Component);

    function RadioGroup() {
        _classCallCheck(this, RadioGroup);

        var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).apply(this, arguments));

        _this.state = {
            value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
        };
        _this.reset = function () {
            return setTimeout(function () {
                var defaultValue = _this.props.defaultValue;

                _this.onRadioChange(defaultValue);
            });
        };
        _this.onRadioChange = function (newValue) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                value = _this$props.value;

            var newGroupValue = newValue;
            _this.setState({ value: value || newGroupValue });
            if (onChange) {
                onChange(newGroupValue);
            }
        };
        _this.renderChildren = function () {
            var _this$props2 = _this.props,
                inline = _this$props2.inline,
                children = _this$props2.children,
                name = _this$props2.name;
            var value = _this.state.value;

            var newProps = {
                name: name,
                onChange: _this.onRadioChange,
                radioGroupValue: value
            };
            return _react2.default.createElement(_Group2.default, { selection: true, inline: inline }, _reactChildrenUtilities2.default.deepMap(children, function (child) {
                return child.type === _Radio2.default ? _react2.default.cloneElement(child, newProps) : child;
            }));
        };
        _this.assignNode = function (node) {
            _this.groupNode = node;
        };
        _this.render = function () {
            var _this$props3 = _this.props,
                label = _this$props3.label,
                className = _this$props3.className,
                error = _this$props3.error,
                errorMessage = _this$props3.errorMessage,
                tooltip = _this$props3.tooltip;

            var radioGroupClassName = (0, _classnames2.default)('luna-form__field', className);
            return _react2.default.createElement("div", { ref: _this.assignNode, className: radioGroupClassName }, label && _react2.default.createElement("label", { className: "luna-label" }, _react2.default.createElement("strong", null, label)), tooltip, _this.renderChildren(), error && _react2.default.createElement("span", { className: "luna-form__feedback" }, errorMessage));
        };
        return _this;
    }

    _createClass(RadioGroup, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.groupNode) {
                return;
            }
            var firstGroupInput = this.groupNode.querySelector('input');
            this.formNode = firstGroupInput ? firstGroupInput.form : null;
            if (this.formNode) {
                this.formNode.addEventListener('reset', this.reset, false);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var value = _ref.value;

            if (value !== undefined) {
                this.setState({ value: value });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.formNode) {
                this.formNode.removeEventListener('reset', this.reset);
            }
        }
    }]);

    return RadioGroup;
}(_react.Component);

RadioGroup.defaultProps = {
    className: '',
    inline: false,
    error: false,
    errorMessage: 'Radio group error message'
};
RadioGroup.propTypes = {
    name: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    inline: _propTypes2.default.bool,
    value: _propTypes2.default.node,
    defaultValue: _propTypes2.default.node.isRequired,
    error: _propTypes2.default.bool,
    errorMessage: _propTypes2.default.string,
    children: _propTypes2.default.node.isRequired,
    label: _propTypes2.default.string.isRequired,
    tooltip: _propTypes2.default.node
};
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map